import constants from '../web-sh/src/config/constants';
import images from '../assets/images';
import urls from './urls';

const SCAM_URL_TYPE = {
  FinanceBanking: 'fake_finance_banking',
  FakeEcommerce: 'fake_ecommerce',
  FakeGovernment: 'fake_government',
  FakePublicService: 'fake_public_service',
  FakeLoginPage: 'fake_login_page',
  FakeGiveaway: 'fake_giveaway',
  Malicious: 'malicious',
  ScamOnlineStore: 'scam_online_store',
  InvestmentScam: 'investment_scam',
  Other: 'other',
}

const SCAM_FACEBOOK_TYPE = {
  FakeMe: 'fake_me',
  FakeOrganization: 'fake_organization',
  FakeBrand: 'fake_brand',
  FakeCelebrity: 'fake_celebrity',
  FakePromotion: 'fake_promotion',
  FakeJob: 'fake_job',
  SpamLink: 'spam_link',
  Gambling: 'gambling',
  Other: 'other',
}

const SCAM_PHONE_TYPE = {
  FakePolice: 'fake_police',
  FakeElectricityCompany: 'fake_electricity_company',
  FakeBanking: 'fake_bank_credit_securities',
  PhoneSpam: 'phone_spam',
  OnlineDelivery: 'online_delivery',
  FakePrize: 'fake_ads_prize',
  CustomerService: 'customer_service',
  RealEstate: 'real_estate',
  Insurance: 'insurance',
  Scam: 'scam',
  Other: 'other',
}

const SCAM_TYPE = {
  Url: 'url',
  Facebook: 'facebook',
  Phone: 'phone'
}

export default {
  ...constants,
  PAGE_SIZE: 15,
  SERVICE_SCOPE: 'pwdmanager',
  CLIENT_ID: 'web',
  SUB_DOMAIN: '.maily.org',

  PLAN_PERIOD: {
    MONTHLY: 'monthly',
    YEARLY: 'yearly'
  },

  FREE_PLAN_LIMIT: {
    1: 100,
    2: 50,
    3: 5,
    4: 10,
    5: 10,
    7: 5
  },

  PLANS: {
    FREE: 'pm_free',
    PREMIUM: 'pm_premium',
    FAMILY: 'pm_family',
    ENTERPRISE: 'pm_enterprise',
    LIFETIME_FAMILY: 'pm_lifetime_family',
    LIFETIME_TEAM: 'pm_lifetime_team',
    LIFETIME_PREMIUM: 'pm_lifetime_premium',
    BUSINESS_PREMIUM: 'pm_business_premium'
  },
  
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  STRIPE_KEY: process.env.REACT_APP_STRIPE_KEY,

  BROWSERS: [
    {
      imgSrc: images.ChromeIcon,
      name: 'Chrome',
      value: 'chrome',
      active: true,
      link: urls.CHROME_EXTENSION_URL
    },
    {
      imgSrc: images.FirefoxIcon,
      name: 'Firefox',
      value: 'firefox',
      active: true,
      link: urls.FIREFOX_EXTENSION_URL
    },
    {
      imgSrc: images.EdgeIcon,
      name: 'Edge',
      value: 'edge',
      active: true,
      link: urls.CHROME_EXTENSION_URL
    },
    {
      imgSrc: images.BraveIcon,
      name: 'Brave',
      value: 'brave',
      active: true,
      link: urls.CHROME_EXTENSION_URL
    },
    {
      imgSrc: images.SafariIcon,
      name: 'Safari',
      value: 'safari',
      active: false,
      link: ''
    }
  ],
  ERROR_CODES: [
    "0000",
    "0002",
    "0004",
    "0005",
    "0008",
    "0009",
    "1001",
    "1002",
    "1003",
    "1004",
    "1005",
    "1006",
    "1007",
    "1008",
    "1009",
    "1010",
    "1011",
    "1012",
    "3003",
    "3005",
    "5000",
    "5001",
    "5002",
    "5003",
    "7002",
    "7003",
    "7004",
    "7005",
    "7006",
    "7007",
    "7008",
    "7009",
    "7010",
    "7011",
    "7012",
    "7013",
    "7014",
    "7015",
    "7016",
    "7017",
    "7018",
    "7019",
    "8000",
    "8001",
    "9000",
    "10000",
  ],

  SCAM_URL_TYPE,
  SCAM_URL_TYPE_FAKES: [
    SCAM_URL_TYPE.FinanceBanking,
    SCAM_URL_TYPE.FakeEcommerce,
    SCAM_URL_TYPE.FakeGovernment,
    SCAM_URL_TYPE.FakePublicService,
    SCAM_URL_TYPE.FakeLoginPage,
  ],
  SCAM_FACEBOOK_TYPE,
  SCAM_FACEBOOK_TYPE_FAKES: [
    SCAM_FACEBOOK_TYPE.FakeOrganization,
    SCAM_FACEBOOK_TYPE.FakeBrand,
  ],
  SCAM_PHONE_TYPE,
  SCAM_PHONE_TYPE_FAKES: [
  ],
  SCAM_TYPE,
};
